import Image, { ImageProps } from 'next/image'
import { BREAKPOINTS } from '@boltenergy-be/design-system'

const HeroImage = ({
  quality = 80,
  sizes = `(min-width: ${BREAKPOINTS.tablet}px) 100vw, 100vh`,
  ...props
}: Pick<ImageProps, 'src' | 'alt' | 'quality' | 'sizes' | 'className'>) => {
  return (
    // Note: Using next/image instead of @boltenergy-be/design-system image here to prevent blurry home hero image
    // - Always try to use DS image component. This is an exception to optimize the main hero better.
    <Image {...{ quality, sizes }} {...props} priority fetchPriority="high" placeholder="blur" alt="" fill style={{ objectFit: 'cover' }} />
  )
}

export default HeroImage
